module.exports = __webpack_public_path__ + "static/media/lds-logo_sm.4e34c881.svg";